import React from 'react';
import Lote from './Lote';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';


const Manzana = ({ idManzana, lotes, currencySymbol, onSeleccionarLote, onAbrirModalManzana, obtenerUrlImagenManzana }) => {
  //const columns = Math.ceil(Math.sqrt(lotes.length));
  const columns = 4;
  const urlImagenManzana = obtenerUrlImagenManzana(idManzana);
   
  return (
    <Box sx={{ 
      color: 'white',
      margin: '10px',
      //backgroundImage: 'linear-gradient(to left, #aaaaaa, #DDDDDD)',
      backgroundColor: '#DDDDDD',
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: '10px',
      padding: '1px',
      paddingTop: 0, // Asegúrate de que no haya padding en la parte superior
      borderRadius: '10px',
      width: '400px',
      minHeight: '300px',
      boxShadow: '0px 1px 10px rgba(0, 0, 0, 0.50)',
      gridTemplateRows: '50px auto', // Ejemplo: altura de 50px para el encabezado y el resto para los lotes
    }}>
     <Box sx={{ 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'transparent',
        color: '#FFFFFF',
        width:'90%',
        padding: '10px',
        margin: 0, // Elimina los márgenes para que el encabezado quede pegado al borde superior
        gridRow: '1', // Asegura que el encabezado esté en la primera fila
        gridColumn: '1 / -1', // Asegura que el encabezado ocupe todas las columnas
      }}>
        <Typography
          variant="h5"
          component="h2"
          sx={{
            fontFamily: 'Rubik, sans-serif',
            fontStyle: 'oblique',
            fontVariant: 'traditional',
            color:"#00470f"
          }}
        >
          Manzana {idManzana}
        </Typography>
        <Button 
            variant="contained"
            onClick={() => onAbrirModalManzana(idManzana)}
            sx={{ bgcolor: '#DDDDDD', color:'#000000', borderRadius:"5px", border:"1px","&:hover": {
              color:'#ffffff',
              backgroundColor: "#00470f",
            }, }}
          >
            Ver plano
          </Button>
      </Box>
      <Box 
        sx={{ 
          color: 'white',
          margin: '10px',
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap: '10px',
          padding: '1px',
          paddingTop: 0, // Asegúrate de que no haya padding en la parte superior
          borderRadius: '1px',
          width: '390px',
          minHeight: '300px',
        }}>
      {lotes.map((lote, index) => (
        <Lote key={index} 
          lote={lote} 
          onSeleccionarLote={onSeleccionarLote} 
          obtenerUrlImagenManzana={obtenerUrlImagenManzana} 
          idManzana={idManzana} 
          currencySymbol={currencySymbol}
        />

      ))}
      </Box>
    </Box>
  );
};

export default Manzana;
